import {
     SET_ADMIN_PRODUCT_DETAILS,
     ADD_ADMIN_PRODUCT_REVIEW,
     UPDATE_ADMIN_PRODUCT_REVIEW,
     DELETE_ADMIN_PRODUCT_REVIEW,
     ADD_ADMIN_PRODUCT_MEDIA,
     UPDATE_ADMIN_PRODUCT_MEDIA,
     DELETE_ADMIN_PRODUCT_MEDIA,
     ADD_ADMIN_PRODUCT_INSTRUCTOR_LEADER,
     SET_ADMIN_PRODUCT_PREREQUISITE,
     ADD_ADMIN_LESSON,
     UPDATE_ADMIN_LESSON,
     DELETE_ADMIN_LESSON,
     ADD_ADMIN_PRODUCT_EVENT,
     UPDATE_ADMIN_PRODUCT_EVENT,
     DELETE_ADMIN_PRODUCT_EVENT,
     ADD_ADMIN_PRODUCT_FAQ,
     UPDATE_ADMIN_PRODUCT_FAQ,
     DELETE_ADMIN_PRODUCT_FAQ,
} from './actions';

const INITIAL_STATE = null;

const productDetailsReducer = (state = INITIAL_STATE, action) => {
     const productDetails = state ? { ...state } : state;
     switch (action.type) {
          // Product Details
          case SET_ADMIN_PRODUCT_DETAILS: {
               return action.payload;
          }

          // Product Review
          case ADD_ADMIN_PRODUCT_REVIEW: {
               productDetails.reviews.push(action.payload);
               return productDetails;
          }
          case UPDATE_ADMIN_PRODUCT_REVIEW: {
               const newReviews = productDetails.reviews.map((review) => {
                    if (review.id === action.payload.id) {
                         return { ...review, ...action.payload };
                    }
                    return review;
               });
               const newProductDetails = {
                    ...productDetails,
                    reviews: newReviews,
               };
               return newProductDetails;
          }
          case DELETE_ADMIN_PRODUCT_REVIEW: {
               const newReviews = productDetails.reviews.filter((review) => review.id !== action.payload);
               const newProductDetails = {
                    ...productDetails,
                    reviews: newReviews,
               };
               return newProductDetails;
          }

          // Product Media
          case ADD_ADMIN_PRODUCT_MEDIA: {
               productDetails.medias.push(action.payload);
               return productDetails;
          }
          case UPDATE_ADMIN_PRODUCT_MEDIA: {
               const newMedias = productDetails.medias.map((media) => {
                    if (media.id === action.payload.id) {
                         return { ...media, ...action.payload };
                    }
                    return media;
               });
               const newProductDetails = {
                    ...productDetails,
                    medias: newMedias,
               };
               return newProductDetails;
          }
          case DELETE_ADMIN_PRODUCT_MEDIA: {
               const newMedias = productDetails.medias.filter((media) => media.id !== action.payload);
               const newProductDetails = {
                    ...productDetails,
                    medias: newMedias,
               };
               return newProductDetails;
          }

          // Product Instructor
          case ADD_ADMIN_PRODUCT_INSTRUCTOR_LEADER: {
               productDetails.productInstructors = action.payload;
               return productDetails;
          }

          // Product Prerequisite
          case SET_ADMIN_PRODUCT_PREREQUISITE: {
               productDetails.productPrerequisites = action.payload;
               return productDetails;
          }

          // Lesson
          case ADD_ADMIN_LESSON: {
               productDetails.lessons.push(action.payload);
               return productDetails;
          }
          case UPDATE_ADMIN_LESSON: {
               const newReviews = productDetails.lessons.map((lesson) => {
                    if (lesson.id === action.payload.id) {
                         return { ...lesson, ...action.payload };
                    }
                    return lesson;
               });
               const newProductDetails = {
                    ...productDetails,
                    lessons: newReviews,
               };
               return newProductDetails;
          }
          case DELETE_ADMIN_LESSON: {
               const newReviews = productDetails.lessons.filter((lesson) => lesson.id !== action.payload);
               const newProductDetails = {
                    ...productDetails,
                    lessons: newReviews,
               };
               return newProductDetails;
          }

          // Product Event
          case ADD_ADMIN_PRODUCT_EVENT: {
               productDetails.events?.rows.push(action.payload);
               return productDetails;
          }
          case UPDATE_ADMIN_PRODUCT_EVENT: {
               const newEvent = productDetails.events.rows?.map((event) => {
                    if (event.id === action.payload.id) {
                         return { ...event, ...action.payload };
                    }

                    return event;
               });

               const newProductDetails = {
                    ...productDetails,
                    events: { ...productDetails.events, rows: newEvent },
               };
               return newProductDetails;
          }
          case DELETE_ADMIN_PRODUCT_EVENT: {
               const newEvent = productDetails.events.rows?.filter((event) => event.id !== action.payload);
               const newProductDetails = {
                    ...productDetails,
                    events: { ...productDetails.events, rows: newEvent },
               };
               return newProductDetails;
          }

          // Product FAQs
          case ADD_ADMIN_PRODUCT_FAQ: {
               productDetails.faqs.push(action.payload);
               return productDetails;
          }
          case UPDATE_ADMIN_PRODUCT_FAQ: {
               const newItems = productDetails.faqs.map((item) => {
                    if (item.id === action.payload.id) {
                         return { ...item, ...action.payload };
                    }
                    return item;
               });
               const newProductDetails = {
                    ...productDetails,
                    faqs: newItems,
               };
               return newProductDetails;
          }
          case DELETE_ADMIN_PRODUCT_FAQ: {
               const newItems = productDetails.faqs.filter((item) => item.id !== action.payload);
               const newProductDetails = {
                    ...productDetails,
                    faqs: newItems,
               };
               return newProductDetails;
          }

          default:
               return state;
     }
};

export const getProductReviewById = (state, rid) => state.admin.productDetails.reviews.find((review) => review.id === rid);
export const getProductMediaById = (state, mid) => state.admin.productDetails.medias.find((media) => media.id === mid);
export const getLessonById = (state, lid) => state.admin.productDetails.lessons.find((lesson) => lesson.id === lid);
export const getProductEventById = (state, eid) => state.admin.productDetails.events.rows?.find((event) => event.id === eid);
export const getProductFaqById = (state, fid) => state.admin.productDetails.faqs.find((faq) => faq.id === fid);

export default productDetailsReducer;
